
import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { UtilityServicesService } from 'src/app/services/utility-service/utility-services.service';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';


@Component({
  selector: 'app-coding-club-result',
  templateUrl: './coding-club-result.component.html',
  styleUrls: ['./coding-club-result.component.scss']
})
export class CodingClubResultComponent implements OnInit {
  @ViewChild('downloadLink') downloadLink: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  campaignId;
  userName =  localStorage.getItem('user')
  downloadResult = false;
  resultTopic: any;
  scoreInfo:any;
  token:any;
  username:any;
  codinClubTopicWiseMarks: any[];
  currentDate: any;
  perCentage: any;
  overallProfeciency: string;

  constructor(
    private utilityservice: UtilityServicesService,
    private route: ActivatedRoute,
    private utilityServicesService:UtilityServicesService
  ) {
  }

  ngOnInit() {
    window.scrollTo(0,0);
    this.token = this.route.snapshot.paramMap.get('token');
    this.username=localStorage.getItem('user');
    this.currentDate=localStorage.getItem('date');
    this.perCentage=localStorage.getItem('perCentage');
    this.overallProfeciency=localStorage.getItem('overallProfeciency');
    var getObj = JSON.parse(localStorage.getItem('resultResponse'));
    this.codinClubTopicWiseMarks=getObj;
    this.getData()
  }

  public tableLabels: string[] = 
  ['Terminal Commands', 'Programming Constructs', 'Patterns and Object oriented Concepts','Object Oriented Programming', 'Web Development', 'Overall Score'];
  
 
  getData() {
    this.utilityservice.getResultTopic().subscribe(response => {
      this.resultTopic = response['data']
      this.scoreInfo=response['score']
    }
    );
  }


  shareResult() {
   
    this.downloadResult = true;
   var data = document.getElementById('contentToConvert');
    
    window.scrollTo(0,0); 
     html2canvas(data).then(canvas => {    
       
      this.canvas.nativeElement.src = canvas.toDataURL();
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/jpeg');
      this.downloadLink.nativeElement.download = 'result.jpeg';      
      this.downloadLink.nativeElement.click();
      this.downloadResult = false;
   });  
   this.utilityServicesService.openSnackBar("Result Downloaded SuccessFully")
}
}


